import { EventEmitter } from "@angular/core";
import { Delegate } from "../../models/UIModels/Delegate";
import { UsageTypes } from "../../models/UIModels/UsageType";
import { ErpType } from "../../models/UIModels/ErpType";
import { Setting } from "../../models/UIModels/Setting";
import { AdditionalFile } from "../../models/UIModels/AdditionalFile";
import { AppsToBeUsed } from "../../models/UIModels/AppsToBeUsed";
import { Person } from "../../models/UIModels/Person";
import { GeneralInfo } from "../../models/UIModels/GeneralInfo";
import { TaxPayer } from "../../models/UIModels/TaxPayer";
import { Other } from "../../models/UIModels/Other";
import { Address } from "../../models/UIModels/Address";
import { NotificationSetting } from "../../models/UIModels/Notification";
import { Constants } from "../../constants/Constants";
import { VknTckn } from "../../models/UIModels/VknTckn";
import { Sales } from "../../models/UIModels/Sales";
import * as i0 from "@angular/core";
export class CustomerApplicationBinderService {
    constructor() {
        this.appDataReceived = new EventEmitter();
        this.customerAddressList = new Array();
        this.customerDelegatesList = new Array();
        this.customerUsageTypesList = new UsageTypes();
        this.customerErpsList = new Array();
        this.customerInvSetting = new Array();
        this.customerArchiveSetting = new Array();
        this.customerDespatchSetting = new Array();
        this.customerSMMSetting = new Array();
        this.customerMMSetting = new Array();
        this.customerDocs = new Array();
        this.personInfo = new Person();
        this.appsToBeUsed = new AppsToBeUsed();
        this.logoFile = new AdditionalFile();
        this.signatureFile = new AdditionalFile();
        this.generalInfo = new GeneralInfo();
        this.taxPayerDetail = new TaxPayer();
        this.otherInfo = new Other();
        this.sales = new Sales();
        this.notificationSettings = new NotificationSetting();
        this.vknTckn = new VknTckn();
        this.newCustomerInvSetting = new Array();
        this.newCustomerArchiveSetting = new Array();
        this.customerDespatchSetting = new Array();
        this.newCustomerInvSetting = new Array();
        this.customerSMMSetting = new Array();
    }
    createOtherModel() {
        if (this.customerApplication) {
            this.otherInfo.GoLiveDate = this.customerApplication.GIB_REGISTER_DATE;
            this.otherInfo.Note = this.customerApplication.NOTES;
            this.otherInfo.StartGibProcess = this.customerApplication.REGISTERTOGIB;
        }
        return this.otherInfo;
    }
    createSalesModel() {
        if (this.customerApplication) {
            this.sales.HasFinancialSeal = this.customerApplication.HAS_FINANCIAL_SEAL;
            this.sales.HasFinancialSealValid = this.customerApplication.HAS_FINANCIAL_SEAL_VALID;
            this.sales.FinancialSealPasswordKnown = this.customerApplication.FINANCIAL_SEAL_PASSWORD_KNOWN;
            this.sales.HasTraApplication = this.customerApplication.HAS_TRA_APPLICATION;
        }
        return this.sales;
    }
    createAdditionalDocsModel() {
        if (this.customerApplication && this.customerApplication.CUSTOMERDOCS) {
            this.customerDocs = new Array();
            this.customerApplication.CUSTOMERDOCS.forEach((doc) => {
                var file = new AdditionalFile(doc.FILE_NAME, doc.BASE64, doc.FILE_SIZE, doc.FILE_TYPE, doc.FILE_CATEGORY);
                this.customerDocs.push(file);
            });
        }
        return this.customerDocs;
    }
    createAdditionalDocsModelForNewProducts() {
        if (this.customerApplication && this.customerApplication.RecentlyPurchasedProducts) {
            this.customerDocsForNewProducts = new Array();
            this.customerApplication.RecentlyPurchasedProducts.Documents.forEach((doc) => {
                var file = new AdditionalFile(doc.FILE_NAME, doc.BASE64, doc.FILE_SIZE, doc.FILE_TYPE, doc.FILE_CATEGORY);
                this.customerDocsForNewProducts.push(file);
            });
        }
        return this.customerDocsForNewProducts;
    }
    createMMSettingsModel() {
        if (this.customerApplication && this.customerApplication.CUSTOMERMMSETTINGS) {
            this.customerMMSetting = new Array();
            this.customerApplication.CUSTOMERMMSETTINGS.forEach((branch) => {
                var mmSetting = new Setting();
                mmSetting.AddressDescription = branch.ADDRESS;
                mmSetting.Branch = branch.BRANCH_NAME;
                mmSetting.IsIdAutoGenerated = branch.INV_ID_AUTO_GENERATE;
                mmSetting.Prefix = branch.INV_PREFIX;
                mmSetting.Source = branch.SOURCE;
                this.customerMMSetting.push(mmSetting);
            });
        }
        return this.customerMMSetting;
    }
    createSMMSettingsModel() {
        if (this.customerApplication && this.customerApplication.CUSTOMERSMMSETTINGS) {
            this.customerSMMSetting = new Array();
            this.customerApplication.CUSTOMERSMMSETTINGS.forEach((branch) => {
                var smmSetting = new Setting();
                smmSetting.AddressDescription = branch.ADDRESS;
                smmSetting.Branch = branch.BRANCH_NAME;
                smmSetting.IsIdAutoGenerated = branch.INV_ID_AUTO_GENERATE;
                smmSetting.Prefix = branch.INV_PREFIX;
                smmSetting.Source = branch.SOURCE;
                this.customerSMMSetting.push(smmSetting);
            });
        }
        return this.customerSMMSetting;
    }
    createDespatchSettingsModel() {
        if (this.customerApplication && this.customerApplication.CUSTOMERDESALIASLIST) {
            this.customerDespatchSetting = new Array();
            this.customerApplication.CUSTOMERDESALIASLIST.forEach((alias) => {
                var desSetting = new Setting();
                desSetting.AddressDescription = alias.DES_ADDRESS;
                desSetting.Alias = alias.DES_ALIASFIRSTPART;
                desSetting.Domain = alias.DES_ALIASDENDPART;
                desSetting.Role = alias.DES_ALIAS_ROLE;
                desSetting.IsIdAutoGenerated = alias.DES_ID_AUTO_GENERATE;
                desSetting.Prefix = alias.DES_PREFIX;
                desSetting.FullAlias = Constants.URNMAIL + desSetting.Alias + "@" + desSetting.Domain;
                desSetting.CreatePkAlias = alias.DES_PK_AUTO_GENERATE;
                desSetting.GbPkPairingNo = alias.PAIRING_NO;
                desSetting.Source = alias.SOURCE;
                this.customerDespatchSetting.push(desSetting);
            });
        }
        return this.customerDespatchSetting;
    }
    createArchiveSettingsModel() {
        if (this.customerApplication && this.customerApplication.CUSTOMERARCHIVESETTINGS) {
            this.customerArchiveSetting = new Array();
            this.customerApplication.CUSTOMERARCHIVESETTINGS.forEach((branch) => {
                var arcSetting = new Setting();
                arcSetting.AddressDescription = branch.ADDRESS;
                arcSetting.Branch = branch.BRANCH_NAME;
                arcSetting.IsIdAutoGenerated = branch.INV_ID_AUTO_GENERATE;
                arcSetting.Prefix = branch.INV_PREFIX;
                arcSetting.Source = branch.SOURCE;
                this.customerArchiveSetting.push(arcSetting);
            });
        }
        return this.customerArchiveSetting;
    }
    createInvoiceSettingsModel() {
        if (this.customerApplication && this.customerApplication.CUSTOMERALIASLIST) {
            this.customerInvSetting = new Array();
            this.customerApplication.CUSTOMERALIASLIST.forEach((alias) => {
                var invSetting = new Setting();
                invSetting.AddressDescription = alias.ADDRESS;
                invSetting.Domain = alias.ALIASDENDPART;
                invSetting.Alias = alias.ALIASFIRSTPART;
                invSetting.Role = alias.ALIAS_ROLE;
                invSetting.IsIdAutoGenerated = alias.INV_ID_AUTO_GENERATE;
                invSetting.Prefix = alias.INV_PREFIX;
                invSetting.FullAlias = Constants.URNMAIL + invSetting.Alias + "@" + invSetting.Domain;
                invSetting.GbPkPairingNo = alias.PAIRING_NO;
                invSetting.CreatePkAlias = alias.INV_PK_AUTO_GENERATE;
                invSetting.Source = alias.SOURCE;
                this.customerInvSetting.push(invSetting);
            });
        }
        return this.customerInvSetting;
    }
    createErpInfoModel() {
        if (this.customerApplication && this.customerApplication.CUSTOMERERPS) {
            this.customerErpsList = new Array();
            this.customerApplication.CUSTOMERERPS.forEach((custErp) => {
                var erp = new ErpType();
                erp.Erp = custErp.NAME;
                erp.Version = custErp.VERSION;
                this.customerErpsList.push(erp);
            });
        }
        return this.customerErpsList;
    }
    createUsageTypesModel() {
        if (this.customerApplication && this.customerApplication.CUSTOMERUSAGETYPES_PER_PRODUCT) {
            this.customerUsageTypesList = new UsageTypes();
            var usageTypes = new UsageTypes();
            usageTypes.USAGETYPEFORMINVOICE = this.customerApplication.CUSTOMERUSAGETYPES_PER_PRODUCT.USAGETYPEFORMINVOICE;
            usageTypes.USAGETYPEFORMARCHIVE = this.customerApplication.CUSTOMERUSAGETYPES_PER_PRODUCT.USAGETYPEFORMARCHIVE;
            usageTypes.USAGETYPEFORMDESPATCH = this.customerApplication.CUSTOMERUSAGETYPES_PER_PRODUCT.USAGETYPEFORMDESPATCH;
            usageTypes.USAGETYPEFORMSMM = this.customerApplication.CUSTOMERUSAGETYPES_PER_PRODUCT.USAGETYPEFORMSMM;
            usageTypes.USAGETYPEFORMMM = this.customerApplication.CUSTOMERUSAGETYPES_PER_PRODUCT.USAGETYPEFORMMM;
            usageTypes.USAGETYPEFORMDEFTER = this.customerApplication.CUSTOMERUSAGETYPES_PER_PRODUCT.USAGETYPEFORMDEFTER;
            usageTypes.USAGETYPEFORMMUTABAKAT = this.customerApplication.CUSTOMERUSAGETYPES_PER_PRODUCT.USAGETYPEFORMMUTABAKAT;
        }
        this.customerUsageTypesList = usageTypes;
        return this.customerUsageTypesList;
    }
    createNewUsageTypesModel() {
        if (this.customerApplication &&
            this.customerApplication.RecentlyPurchasedProducts &&
            this.customerApplication.RecentlyPurchasedProducts.CustomerUsageTypesPerProduct) {
            this.customerUsageTypesListForNewProducts = new UsageTypes();
            var usageTypes = new UsageTypes();
            usageTypes.USAGETYPEFORMINVOICE = this.customerApplication.RecentlyPurchasedProducts.CustomerUsageTypesPerProduct.USAGETYPEFORMINVOICE;
            usageTypes.USAGETYPEFORMARCHIVE = this.customerApplication.RecentlyPurchasedProducts.CustomerUsageTypesPerProduct.USAGETYPEFORMARCHIVE;
            usageTypes.USAGETYPEFORMDESPATCH = this.customerApplication.RecentlyPurchasedProducts.CustomerUsageTypesPerProduct.USAGETYPEFORMDESPATCH;
            usageTypes.USAGETYPEFORMSMM = this.customerApplication.RecentlyPurchasedProducts.CustomerUsageTypesPerProduct.USAGETYPEFORMSMM;
            usageTypes.USAGETYPEFORMMM = this.customerApplication.RecentlyPurchasedProducts.CustomerUsageTypesPerProduct.USAGETYPEFORMMM;
            usageTypes.USAGETYPEFORMDEFTER = this.customerApplication.RecentlyPurchasedProducts.CustomerUsageTypesPerProduct.USAGETYPEFORMDEFTER;
            usageTypes.USAGETYPEFORMMUTABAKAT = this.customerApplication.RecentlyPurchasedProducts.CustomerUsageTypesPerProduct.USAGETYPEFORMMUTABAKAT;
        }
        this.customerUsageTypesListForNewProducts = usageTypes;
        return this.customerUsageTypesListForNewProducts;
    }
    createDelegateInfoModel() {
        if (this.customerApplication && this.customerApplication.CUSTOMERDELEGATES) {
            this.customerDelegatesList = new Array();
            this.customerApplication.CUSTOMERDELEGATES.forEach((dlg) => {
                var delegate = new Delegate();
                delegate.Email = dlg.EMAIL;
                delegate.FirstName = dlg.FIRST_NAME;
                delegate.LastName = dlg.LAST_NAME;
                delegate.KepAddress = dlg.KEPADDRESS;
                delegate.PhoneNumber = dlg.PHONE;
                delegate.TCKN = dlg.TCKN;
                delegate.IsMutabakat = dlg.IS_MUTABAKAT_DELEGATE;
                delegate.IsLedger = dlg.IS_LEDGER_DELEGATE;
                this.customerDelegatesList.push(delegate);
            });
        }
        return this.customerDelegatesList;
    }
    createAddressModel() {
        if (this.customerApplication && this.customerApplication.CUSTOMERADDRESSES) {
            this.customerAddressList = new Array();
            this.customerApplication.CUSTOMERADDRESSES.forEach((addresInfo) => {
                var address = new Address();
                address.District = addresInfo.DISTRICT;
                address.Street = addresInfo.STREET_NAME;
                address.BuildingName = addresInfo.BUILDING_NAME;
                address.BuildingNo = addresInfo.BUILDING_NUMBER;
                address.City = addresInfo.CITY;
                address.CitySubdivision = addresInfo.CITY_SUBDIVISION_NAME;
                address.Country = addresInfo.COUNTRY;
                address.Description = addresInfo.DESCRIPTION;
                address.Email = addresInfo.EMAIL;
                address.Fax = addresInfo.FAX_NO;
                address.WorkPhoneNumber = addresInfo.PHONE_NO;
                address.PostalZone = addresInfo.POSTAL_ZONE;
                address.DoorNumber = addresInfo.ROOM;
                address.Website = addresInfo.WEBSITE;
                address.Street = address.Street;
                this.customerAddressList.push(address);
            });
        }
        return this.customerAddressList;
    }
    createTaxPayerDetailModel() {
        if (this.customerApplication) {
            this.taxPayerDetail.LegalCenter = this.customerApplication.LEGAL_OFFICE;
            this.taxPayerDetail.FoundationDate = this.customerApplication.FOUNDATION_DATE;
            this.taxPayerDetail.Chamber = this.customerApplication.BOARDOFTRADE_NAME;
            this.taxPayerDetail.ChamberRegNo = this.customerApplication.BOARDOFTRADE_ID;
            this.taxPayerDetail.MersisNo = this.customerApplication.MERSIS_NO;
            this.taxPayerDetail.TapdkNo = this.customerApplication.TAPDK_NO;
            this.taxPayerDetail.TradeRegistryNumber = this.customerApplication.TRADE_REGISTRATION_NO;
            this.taxPayerDetail.TradeRegistryOffice = this.customerApplication.TRADE_REGISTRATION_OFFICE;
            this.taxPayerDetail.ESignatureExpDate = this.customerApplication.DIGITAL_SIGN_VALIDITY_DATE;
            this.taxPayerDetail.ESignatureExpDate = this.customerApplication.DIGITAL_SIGN_VALIDITY_DATE;
            this.taxPayerDetail.TaxOfficeName = this.customerApplication.TAX_OFFICE;
        }
        return this.taxPayerDetail;
    }
    createGeneralInfoModel() {
        if (this.customerApplication) {
            this.generalInfo.CompanyName = this.customerApplication.COMPANY_NAME;
            this.generalInfo.TaxPayerType = this.customerApplication.USER_TYPE;
            this.generalInfo.VKNTCKN = this.customerApplication.IDENTIFIER;
            this.generalInfo.FirstName = this.customerApplication.FIRST_NAME;
            //this.generalInfo.MiddleName = this.customerApplication.MIDDLE_NAME;
            this.generalInfo.LastName = this.customerApplication.FAMILY_NAME;
            if (this.generalInfo.VKNTCKN && this.generalInfo.VKNTCKN.length == 11) {
                this.generalInfo.CompanyName = Constants.EMPTY_STRING;
                this.generalInfo.CommercialTitle = this.customerApplication.COMMERCIAL_TITLE;
                this.generalInfo.BirthYear = this.customerApplication.BIRTH_YEAR;
                if (this.generalInfo.CommercialTitle) {
                    this.generalInfo.LastName = this.generalInfo.LastName.replace(this.generalInfo.CommercialTitle, Constants.EMPTY_STRING);
                }
            }
        }
        return this.generalInfo;
    }
    createLogoModel() {
        if (this.customerApplication && this.customerApplication.CUSTOMERFILES) {
            if (this.customerApplication.CUSTOMERFILES.INVOICE_FILE) {
                var logoFile = this.customerApplication.CUSTOMERFILES.INVOICE_FILE.find((x) => x.FILE_KIND == "LOGO");
                if (logoFile) {
                    this.logoFile.FileData = logoFile.BASE64;
                    this.logoFile.FileType = logoFile.FILE_TYPE;
                    this.logoFile.FileSize = logoFile.FILE_SIZE ? logoFile.FILE_SIZE.toString() : "";
                    this.logoFile.FileName = logoFile.FILE_NAME;
                    return this.logoFile;
                }
            }
        }
        return undefined;
    }
    createSignatureModel() {
        if (this.customerApplication && this.customerApplication.CUSTOMERFILES) {
            if (this.customerApplication.CUSTOMERFILES.ARCHIVE_FILE) {
                var signatureFile = this.customerApplication.CUSTOMERFILES.ARCHIVE_FILE.find((x) => x.FILE_KIND == "IMZA");
                if (signatureFile) {
                    this.signatureFile.FileData = signatureFile.BASE64;
                    this.signatureFile.FileType = signatureFile.FILE_TYPE;
                    this.signatureFile.FileSize = signatureFile.FILE_SIZE ? signatureFile.FILE_SIZE.toString() : "";
                    this.signatureFile.FileName = signatureFile.FILE_NAME;
                    return this.signatureFile;
                }
            }
            else if (this.customerApplication.CUSTOMERFILES.INVOICE_FILE) {
                var signatureFileInLogo = this.customerApplication.CUSTOMERFILES.INVOICE_FILE.find((x) => x.FILE_KIND == "IMZA");
                if (signatureFileInLogo) {
                    this.signatureFile.FileData = signatureFileInLogo.BASE64;
                    this.signatureFile.FileType = signatureFileInLogo.FILE_TYPE;
                    this.signatureFile.FileSize = signatureFileInLogo.FILE_SIZE ? signatureFileInLogo.FILE_SIZE.toString() : "";
                    this.signatureFile.FileName = signatureFileInLogo.FILE_NAME;
                    return this.signatureFile;
                }
            }
        }
        return undefined;
    }
    createAppsToBeUsedModel(newStatus) {
        if (newStatus) {
            this.appsToBeUsed.Invoice = false;
            this.appsToBeUsed.Archive = false;
            this.appsToBeUsed.Despatch = false;
            this.appsToBeUsed.SMM = false;
            this.appsToBeUsed.MM = false;
            this.appsToBeUsed.EDefter = false;
            this.appsToBeUsed.EMutabakat = false;
        }
        else {
            if (this.customerApplication && this.customerApplication.CUSTOMERAPPLICATONMODEL) {
                this.appsToBeUsed.Invoice = this.customerApplication.CUSTOMERAPPLICATONMODEL.EINVOICE;
                this.appsToBeUsed.Archive = this.customerApplication.CUSTOMERAPPLICATONMODEL.EARCHIVE;
                this.appsToBeUsed.Despatch = this.customerApplication.CUSTOMERAPPLICATONMODEL.EDISPATCH;
                this.appsToBeUsed.SMM = this.customerApplication.CUSTOMERAPPLICATONMODEL.ESMM;
                this.appsToBeUsed.MM = this.customerApplication.CUSTOMERAPPLICATONMODEL.EMM;
                this.appsToBeUsed.EDefter = this.customerApplication.CUSTOMERAPPLICATONMODEL.EDEFTER;
                this.appsToBeUsed.EMutabakat = this.customerApplication.CUSTOMERAPPLICATONMODEL.EMUTABAKAT;
            }
            else {
                this.appsToBeUsed.Invoice = true;
            }
        }
        return this.appsToBeUsed;
    }
    createPersonInfoModel() {
        if (this.customerApplication) {
            this.personInfo.FirstName = this.customerApplication.FORM_NAME;
            this.personInfo.LastName = this.customerApplication.FORM_LAST_NAME;
            this.personInfo.Email = this.customerApplication.FORM_EMAIL;
            this.personInfo.PhoneNumber = this.customerApplication.FORM_PHONE;
        }
        return this.personInfo;
    }
    createNotificationSettingsModel() {
        if (this.customerApplication && this.customerApplication.CUSTOMERALIASSETTINGS) {
            this.notificationSettings.Notify = this.customerApplication.CUSTOMERALIASSETTINGS.NS_DO_NOTIFY;
            this.notificationSettings.NotificationEmail = this.customerApplication.CUSTOMERALIASSETTINGS.NS_NOTIFY_EMAIL;
        }
        return this.notificationSettings;
    }
    createVknTcknModel() {
        if (this.customerApplication) {
            this.vknTckn.VKNTCKN = this.customerApplication.IDENTIFIER;
            this.vknTckn.CONFIRMATION_CODE = Constants.EMPTY_STRING;
        }
        return this.vknTckn;
    }
    createNewInvoiceSettingsModel(newStatus) {
        if (newStatus) {
            this.newCustomerInvSetting = [];
        }
        else {
            if (this.customerApplication && this.customerApplication.RecentlyPurchasedProducts) {
                this.newCustomerInvSetting = new Array();
                this.customerApplication.RecentlyPurchasedProducts.Invoice.forEach((alias) => {
                    var invSetting = new Setting();
                    invSetting.AddressDescription = alias.ADDRESS;
                    invSetting.Role = alias.ALIAS_ROLE;
                    invSetting.IsIdAutoGenerated = alias.INV_ID_AUTO_GENERATE;
                    invSetting.Prefix = alias.INV_PREFIX;
                    invSetting.Alias = alias.ALIASFIRSTPART;
                    invSetting.Domain = alias.ALIASDENDPART;
                    invSetting.FullAlias = Constants.URNMAIL + invSetting.Alias + "@" + invSetting.Domain;
                    invSetting.CreatePkAlias = alias.INV_PK_AUTO_GENERATE;
                    invSetting.GbPkPairingNo = alias.PAIRING_NO;
                    this.newCustomerInvSetting.push(invSetting);
                });
            }
        }
        return this.newCustomerInvSetting;
    }
    createNewMMSettingsModel(newStatus) {
        if (newStatus) {
            this.newCustomerMMSetting = [];
        }
        else {
            if (this.customerApplication && this.customerApplication.RecentlyPurchasedProducts) {
                this.newCustomerMMSetting = new Array();
                this.customerApplication.RecentlyPurchasedProducts.Mm.forEach((branch) => {
                    var mmSetting = new Setting();
                    mmSetting.AddressDescription = branch.ADDRESS;
                    mmSetting.Branch = branch.BRANCH_NAME;
                    mmSetting.IsIdAutoGenerated = branch.INV_ID_AUTO_GENERATE;
                    mmSetting.Prefix = branch.INV_PREFIX;
                    this.newCustomerMMSetting.push(mmSetting);
                });
            }
        }
        return this.newCustomerMMSetting;
    }
    createNewSMMSettingsModel(newStatus) {
        if (newStatus) {
            this.newCustomerSMMSetting = [];
        }
        else {
            if (this.customerApplication && this.customerApplication.RecentlyPurchasedProducts) {
                this.newCustomerSMMSetting = new Array();
                this.customerApplication.RecentlyPurchasedProducts.Smm.forEach((branch) => {
                    var smmSetting = new Setting();
                    smmSetting.AddressDescription = branch.ADDRESS;
                    smmSetting.Branch = branch.BRANCH_NAME;
                    smmSetting.IsIdAutoGenerated = branch.INV_ID_AUTO_GENERATE;
                    smmSetting.Prefix = branch.INV_PREFIX;
                    this.newCustomerSMMSetting.push(smmSetting);
                });
            }
        }
        return this.newCustomerSMMSetting;
    }
    createNewDespatchSettingsModel(newStatus) {
        if (newStatus) {
            this.newCustomerDespatchSetting = [];
        }
        else {
            if (this.customerApplication && this.customerApplication.RecentlyPurchasedProducts) {
                this.newCustomerDespatchSetting = new Array();
                this.customerApplication.RecentlyPurchasedProducts.Despatch.forEach((alias) => {
                    var desSetting = new Setting();
                    desSetting.AddressDescription = alias.DES_ADDRESS;
                    desSetting.Role = alias.DES_ALIAS_ROLE;
                    desSetting.IsIdAutoGenerated = alias.DES_ID_AUTO_GENERATE;
                    desSetting.Prefix = alias.DES_PREFIX;
                    desSetting.Alias = alias.DES_ALIASFIRSTPART;
                    desSetting.Domain = alias.DES_ALIASDENDPART;
                    desSetting.FullAlias = Constants.URNMAIL + desSetting.Alias + "@" + desSetting.Domain;
                    desSetting.CreatePkAlias = alias.DES_PK_AUTO_GENERATE;
                    desSetting.GbPkPairingNo = alias.PAIRING_NO;
                    this.newCustomerDespatchSetting.push(desSetting);
                });
            }
        }
        return this.newCustomerDespatchSetting;
    }
    createNewArchiveSettingsModel(newStatus) {
        if (newStatus) {
            this.newCustomerArchiveSetting = [];
        }
        else {
            if (this.customerApplication && this.customerApplication.RecentlyPurchasedProducts) {
                this.newCustomerArchiveSetting = new Array();
                this.customerApplication.RecentlyPurchasedProducts.Archive.forEach((branch) => {
                    var arcSetting = new Setting();
                    arcSetting.AddressDescription = branch.ADDRESS;
                    arcSetting.Branch = branch.BRANCH_NAME;
                    arcSetting.IsIdAutoGenerated = branch.INV_ID_AUTO_GENERATE;
                    arcSetting.Prefix = branch.INV_PREFIX;
                    this.newCustomerArchiveSetting.push(arcSetting);
                });
            }
        }
        return this.newCustomerArchiveSetting;
    }
    createNewLogoModel(newStatus) {
        if (newStatus) {
            return undefined;
        }
        else {
            if (this.customerApplication &&
                this.customerApplication.RecentlyPurchasedProducts &&
                this.customerApplication.RecentlyPurchasedProducts.CustomerFiles) {
                var invFile = this.customerApplication.RecentlyPurchasedProducts.CustomerFiles.INVOICE_FILE;
                if (invFile) {
                    var logoFile = invFile.find((x) => x.FILE_KIND == "LOGO");
                    if (logoFile) {
                        this.logoFile.FileData = logoFile.BASE64;
                        this.logoFile.FileType = logoFile.FILE_TYPE;
                        this.logoFile.FileSize = logoFile.FILE_SIZE.toString();
                        this.logoFile.FileName = logoFile.FILE_NAME;
                        return this.logoFile;
                    }
                }
            }
            return undefined;
        }
    }
    createNewSignatureModel(newStatus) {
        if (newStatus) {
            return undefined;
        }
        else {
            if (this.customerApplication &&
                this.customerApplication.RecentlyPurchasedProducts &&
                this.customerApplication.RecentlyPurchasedProducts.CustomerFiles) {
                var arcFile = this.customerApplication.RecentlyPurchasedProducts.CustomerFiles.ARCHIVE_FILE;
                if (arcFile) {
                    var signatureFile = arcFile.find((x) => x.FILE_KIND == "IMZA");
                    if (signatureFile) {
                        this.signatureFile.FileData = signatureFile.BASE64;
                        this.signatureFile.FileType = signatureFile.FILE_TYPE;
                        this.signatureFile.FileSize = signatureFile.toString();
                        this.signatureFile.FileName = signatureFile.FILE_NAME;
                        return this.signatureFile;
                    }
                }
            }
            return undefined;
        }
    }
    createNewNotificationSettingsModel(newStatus) {
        if (newStatus) {
            this.newNotificationSettings = new NotificationSetting();
            this.newNotificationSettings.Notify = -1;
            this.newNotificationSettings.NotificationEmail = this.customerApplication.FORM_EMAIL;
        }
        else {
            if (this.customerApplication &&
                this.customerApplication.RecentlyPurchasedProducts &&
                this.customerApplication.RecentlyPurchasedProducts.NotificationSettings) {
                this.newNotificationSettings = new NotificationSetting();
                var ntfSettings = this.customerApplication.RecentlyPurchasedProducts.NotificationSettings;
                this.newNotificationSettings.Notify = ntfSettings.NS_DO_NOTIFY;
                this.newNotificationSettings.NotificationEmail = ntfSettings.NS_NOTIFY_EMAIL;
            }
        }
        return this.newNotificationSettings;
    }
}
CustomerApplicationBinderService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function CustomerApplicationBinderService_Factory() { return new CustomerApplicationBinderService(); }, token: CustomerApplicationBinderService, providedIn: "root" });
